import { Animation } from "./Animation";
import animationData from "../lottie.json";

export default function App() {
  return (
    <div>
      <Animation animationData={animationData} />
      <a
        href="https://yazdun.hashnode.dev/add-animations-to-your-react-projects-using-lottiefiles"
        rel="noreferrer"
        target="_blank"
      >
        Read on Hashnode
      </a>
    </div>
  );
}
